/**
 * SECCIONES REUTILIZABLES
 * Definiciones de secciones que se pueden usar en múltiples páginas
 */

export const sections = {
  heroHome: {
    type: "hero",
    id: "hero-principal",
    data: {
      title: "DESPERTAR",
      subtitle: "¿QUÉ HAY DeNTRO?",
      description:
        "CONOCE OTRA FACETA TUYA CON NUESTRA ALUCINANTE REALIDAD VIRTUAL INMERSIVA",
      backgroundMedia: "/images/bg.png",
      mediaType: "image",
      backgroundColor: "#00202C",
      backgroundSize: "cover",
      ctaButton: {
        text: "QUÉ ESPERAR",
        href: "#que-esperar",
        variant: "primary",
      },
      responsive: {
        mobile: {
          title: "DESPERTAR",
          subtitle: "¿QUÉ HAY DeNTRO?",
          description: "REALIDAD VIRTUAL INMERSIVA",
          backgroundMedia: "/images/mobileHomeBanner.webp",
        },
        desktop: {
          title: "DESPERTAR",
          subtitle: "¿QUÉ HAY DeNTRO?",
          description:
            "CONOCE OTRA FACETA TUYA CON NUESTRA ALUCINANTE REALIDAD VIRTUAL INMERSIVA",
          backgroundMedia: "/images/bg.png",
        },
      },
    },
  },
  videoSection: {
    type: "video",
    id: "video-presentacion",
    data: {
      videoUrl:
        "https://videos.ctfassets.net/adsfyhieuvzo/ErKV7JcADhe2hcrTdRE1r/592fc5ed3675494b4c13e2410128b179/Zero_Latency_16x9_JAKE_V8_1080p_lq.webm",
      placeholder: false,
      aspectRatio: "16/9",
      backgroundColor: "#00202C",
      borderRadius: "2xl",
      maxWidth: "6xl",
      autoplay: false,
      controls: true,
      poster: "/images/video-poster.jpg",
    },
  },
  featuresShowcase: {
    type: "features",
    id: "caracteristicas",
    data: {
      backgroundColor: "#00202C",
      animationsEnabled: true,
      features: [
        {
          title: "ENTRA EN NUEVOS MUNDOS",
          description:
            "Prepárate para conocer otro lado de ti mientras te adentras en realidades inimaginables. Desde vagar por mundos de rompecabezas para toda la familia hasta enfrentarte a hordas de zombis no tan amistosos, es hora de despertar lo que hay en tu interior.",
          image: "/images/frame1.png",
          imageAlt: "Persona usando VR en mundo virtual",
          layout: "alternate",
        },
        {
          title: "SUMÉRGETE EN NUESTRO ESPACIO",
          description:
            "Equipado con la última tecnología VR, nuestro centro te sumerge completamente en la experiencia. Sin cables, sin limitaciones, solo tú y mundos infinitos por descubrir.",
          image: "/images/frame2.png",
          imageAlt: "Centro Zero Latency con tecnología VR",
          layout: "alternate",
        },
        {
          title: "DIFUMINA LA REALIDAD",
          description:
            "La línea entre realidad y mundo virtual se desvanece completamente. Solo tú, tu equipo y aventuras que llevarán tu adrenalina al límite.",
          image: "/images/frame3.png",
          imageAlt: "Jugadores en experiencia VR inmersiva",
          layout: "alternate",
        },
      ],
    },
  },
  testimonials: {
    type: "testimonial-section",
    id: "testimonios-clientes",
    data: {
      topColor: "#00202C",
      bottomColor: "#00202C",
      backgroundColor: "#F5F5F5",
      autoplay: true,
      autoplaySpeed: 3000,
      showDots: true,
      showArrows: true,
      effect: "slide",
      testimonials: [
        {
          name: "Jonelle",
          text: "¡Vinimos aquí para un evento de equipo y a todos les encantó! Éramos 14 personas, así que nos dividimos en 2 sesiones e hicimos la de zombies en ambas. ¡Recomiendo encarecidamente y definitivamente volveremos! 🧟",
          rating: 5,
          avatar: null,
          position: "Team Event Organizer",
          date: "2023-01-15",
        },
        {
          name: "Carlos",
          text: "Experiencia increíble. La tecnología es impresionante y la inmersión es total. Definitivamente regresaré con mis amigos.",
          rating: 5,
          avatar: null,
          position: "Gamer",
          date: "2023-02-20",
        },
        {
          name: "María",
          text: "Nunca había experimentado algo así. Es como estar realmente dentro del juego. ¡Súper recomendado!",
          rating: 5,
          avatar: null,
          position: "First-time VR User",
          date: "2023-03-10",
        },
        {
          name: "Ana",
          text: "Nunca había experimentado algo así. Es como estar realmente dentro del juego. ¡Súper recomendado!",
          rating: 5,
          avatar: null,
          position: "First-time VR User",
          date: "2023-03-10",
        },
        {
          name: "José",
          text: "Nunca había experimentado algo así. Es como estar realmente dentro del juego. ¡Súper recomendado!",
          rating: 5,
          avatar: null,
          position: "First-time VR User",
          date: "2023-03-10",
        },
      ],
    },
  },
  gamesShowcase: {
    type: "games-showcase",
    id: "experiencias-disponibles",
    data: {
      title: "NUESTRAS EXPERIENCIAS",
      subtitle: "Elige tu aventura",
      backgroundColor: "#00202C",
      showAll: true,
      featured: ["outbreak", "space-marine", "engineerium"],
    },
  },
  ctaWave: {
    type: "cta-wave",
    id: "franquicia-cta",
    data: {
      topColor: "#00202C",
      bottomColor: "#000000",
      backgroundColor: "#40C0F0",
      title: "¿QUIERES TENER TU PROPIO ZERO LATENCY?",
      description:
        "Únete a nuestra apasionada comunidad global de aventureros que están revolucionando el entretenimiento.",
      ctaButton: {
        text: "LIDERA TU VENUE",
        href: "",
        icon: "ExternalIcon",
      },
      layout: "center",
    },
  },
  experienceDetails: {
    type: "experience-details",
    id: "experience-details",
    data: {
      experienceId: "engineerium",
    },
  },
  footer: {
    type: "footer",
    id: "main-footer",
    data: {
      showLogo: true,
      logoScale: 1.2, // Más pequeño en footer

      // Enlaces rápidos organizados para móvil
      quickLinks: [
        {
          label: "LIDERA TU VENUE",
          href: "",
          external: true,
        },
        {
          label: "PREGUNTAS FRECUENTES",
          href: "",
          external: false,
        },
        {
          label: "SOBRE NOSOTROS",
          href: "",
          external: false,
        },
        {
          label: "NOTICIAS Y PRENSA",
          href: "",
          external: false,
        },
        {
          label: "VALES DE REGALO",
          href: "",
          external: false,
        },
      ],

      // Redes sociales optimizadas para touch
      socialMedia: [
        {
          platform: "facebook",
          url: "",
        },
        {
          platform: "twitter",
          url: "",
        },
        {
          platform: "linkedin",
          url: "",
        },
        {
          platform: "instagram",
          url: "",
        },
        {
          platform: "youtube",
          url: "",
        },
        {
          platform: "tiktok",
          url: "",
        },
      ],

      // Selector de idioma responsive
      languageSelector: {
        show: true,
        current: "ESPAÑOL",
      },

      // Enlaces legales compactos para móvil
      legalLinks: [
        {
          label: "POLÍTICA DE PRIVACIDAD",
          href: "",
        },
        {
          label: "TÉRMINOS",
          href: "",
        },
        {
          label: "COOKIES",
          href: "",
        },
        {
          label: "DIRECTORIO DE LUGARES",
          href: "",
        },
      ],

      copyright: "©2025 Zero Latency MTY. Todos los derechos reservados.",
      backgroundColor: "#000000",
      textColor: "white",
    },
  },
};
